/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import { Outlet } from "react-router-dom";
import loginStyles from "../../styles/Login.module.css"
import Footer from "../../components/layout/footer"
import { useAppDispatch,useAppSelector } from '../../redux/hooks';
import InfoIcon from '@mui/icons-material/Info';
import { setLoginRequested, toggleLogin,setMaintenanceEnabled,isLoggedInSelector } from '../../redux/loginSlice';

export function UnProtectedContainerNoHF(): JSX.Element {

    const dispatch = useAppDispatch();
    const {appMaintenance,maintenanceMessage} = useAppSelector(isLoggedInSelector);

    return (
        <>
            <div className='Basecontainer' style={{top:'0px', bottom:'0px'}}>
                <main className='Basemain' style={{display:"flex",flexDirection:"column"}}>
                    { appMaintenance ? <div className={loginStyles.maintenanceBanner}>
                    <section className={loginStyles.infoMen}> <InfoIcon className={loginStyles.infoicon} /> <div dangerouslySetInnerHTML={{ __html: maintenanceMessage }}></div> </section>
                    </div> : <></> }
                    <Outlet />
                    {/* <Footer /> */}
                </main>
            </div>
        </>
    )

} 